module.exports = __webpack_public_path__ + "img/image-lateral.42ff5c67.png";